import React from 'react';
import { useParams } from 'react-router-dom';
import FormAddEditPost from '../../../components/blog/posts/FormAddEditPost';
import { useGetPostById } from '../../../hooks/blog/posts/useGetPostById';
import LoadingSpinner from '../../../components/global/LoadingSpinner';
import ErrorAlert from '../../../components/global/ErrorAlert';
import WrapperSection from '../../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../../components/global/GlobalBreadcrumbs';

const EditPost = () => {
    const { id } = useParams();

    const { post, isLoading, error } = useGetPostById(id);

    if (isLoading) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <LoadingSpinner />
            </WrapperSection>
        );
    }
    if (error) {
        return (
            <WrapperSection>
                <GlobalBreadcrumbs />
                <ErrorAlert error={error} />
            </WrapperSection>
        );
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPost currentData={post} isEdit={true} />
        </WrapperSection>
    );
};

export default EditPost;
